import AppBar from "./components/0appbar/AppBar";
import Footer from "./components/Footer";
import Toolbar from "@material-ui/core/Toolbar";

import { useAtom } from "jotai";
import { darkThemeAtom } from "./atoms";

import { ThemeProvider } from "@material-ui/core";
import { createTheme } from "@material-ui/core/styles";
import CssBaseline from "@material-ui/core/CssBaseline";

import Box from "@material-ui/core/Box";
import Container from "@material-ui/core/Container";

import Intro from "./components/1intro/Intro";
import About from "./components/2about/About";
import Projects from "./components/3projects/Projects";
import Testimonials from "./components/4testimonials/Testimonials";

// import useOnScreen from "./utils/useOnScreen";
// import { useRef } from "react";

import Slide from "@material-ui/core/Slide";
import { dark, light } from "./mytheme";


function App() {
  const [darkTheme] = useAtom(darkThemeAtom);
  const appliedTheme = createTheme(darkTheme ? dark : light);

  // Call the hook passing in ref and root margin
  // In this case it would only be considered onScreen if more ...
  // ... than 200px of element is visible.

  /*  const refIntro = useRef();
  const onScreenIntro = useOnScreen(refIntro, "-30px", true);

  const refAbout = useRef();
  const onScreenAbout = useOnScreen(refAbout, "-30px", true);

  const refProjects = useRef();
  const onScreenProjects = useOnScreen(refProjects, "-30px", true);

  const refTestimonial = useRef();
  const onScreenTestimonial = useOnScreen(refTestimonial, "-30px", true); */

  return (
    <>
      <ThemeProvider theme={appliedTheme}>
        <CssBaseline />

        <AppBar />

        <Toolbar id='intro' />

        <Slide timeout={900} direction='right' in={true} mountOnEnter unmountOnExit>
          <Box mx={0} my={1} p={0}>
            <Container maxWidth='lg'>
              <Intro />
            </Container>
          </Box>
        </Slide>

        <Slide timeout={900} direction='right' in={true} mountOnEnter unmountOnExit>
          <Box id='about' mx={0} my={1} p={0}>
            <Container maxWidth='lg'>
             
                <About />
             
            </Container>
          </Box>
        </Slide>

        <Slide timeout={900} direction='right' in={true} mountOnEnter unmountOnExit>
          <Box id='projects' mx={0} my={1} p={0}>
            <Container maxWidth='lg'>
          
                <Projects />
          
            </Container>
          </Box>
        </Slide>

        <Slide timeout={900} direction='right' in={true} mountOnEnter unmountOnExit>
          <Box id='testimonials' mx={0} my={1} p={0}>
            <Container maxWidth='lg'>
        
                <Testimonials />
         
            </Container>
          </Box>
        </Slide>

        <Footer />
      </ThemeProvider>
    </>
  );
}
export default App;
